import React from 'react';
import cx from 'clsx';
import Link from 'next/link';
import classes from './Anchor.module.scss';

type AnchorProps = Omit<React.HTMLProps<HTMLAnchorElement>, 'href' | 'ref'> & {
  href?: string;
};

export default function Anchor({
  className,
  href,
  children,
  ...others
}: AnchorProps) {
  if (!href) {
    return null;
  }

  return (
    <Link href={href} className={cx(classes.anchor, className)} {...others}>
      {children}
    </Link>
  );
}
